export const mockTenantData = {
  id: 1,
  name: "White Label Demo",
  slug: "whitelabel-demo",
  invoices_enabled: true,
  support_email: "support@example-label.test",
  default_currency: 0,
  branding_enabled: true,
  // Tenant subscriptions (Stripe) — disabled by default so demo users can enable via Brand Configuration
  subscriptions_enabled: false,
  // WL-only flags (MMD `users/` has no tenant); releases table & dropdowns need these:
  release_admin_approval: true,
  acr_deep_scan: true,
  generate_catalogue_number: false,
  catalogue_number_prefix: "",
  contract_owner: 1,
  privacy_policy_url: process.env.REACT_APP_POLICY_LINK || "https://example.com/privacy-policy",
  terms_and_conditions_url: process.env.REACT_APP_TERMS || "https://example.com/terms-and-conditions",
  cookie_policy_url: "https://example.com/cookie-policy",
  self_signup: true,
  google_oauth: true,
  branding: {
    logo: "",
    logo_topbar_fe: "",
    first_color: "#000a60",
    sidebar_color_fe: "#ffffff",
    font_family_fe: '"Nunito Sans", sans-serif',
    company: "Your Company Name",
    website: "https://example.com",
    display_logo: false,
    form_alignment_fe: "center",
    cookie_policy_url: "https://example.com/cookie-policy",
    terms_and_conditions_url: "https://example.com/terms-and-conditions",
    privacy_policy_url: "https://example.com/privacy-policy",
  },
};

export const mockCurrentUserData = {
  id: 1001,
  username: "demo-admin@example-label.test",
  email: "demo-admin@example-label.test",
  first_name: "Demo",
  last_name: "Admin",
  is_premium_user: true,
  is_employee_account: false,
  is_sub_user: false,
  is_blacklisted: false,
  bulk_upload: true,
  artists_accounting: true,
  statements: true,
  trends: true,
  earnings_drilldown: true,
  music_link: true,
  link_in_bio: true,
  promotion_amount_left: 999,
  credits: 999,
  deployment_credits: 10,
  last_branding_updated: null,
  immersive_audio: true,
  auto_code_generation: true,
  can_add_invoices: true,
  invoicing_limit_reached: true,
  invoicing_available: true,
  invoices_generating: 0,
  invoices: true,
  total_payment_methods: 2,
  distribution: true,
  release_transfer: true,
  promotions: true,
  artists: true,
  labels_enabled: true,
  mastering: true,
  employee_accounts: true,
  total_employee_accounts: 3,
  can_add_takedown: true,
  unlimited_track_amount: true,
  total_allowed_track_amount: 250,
  contract_owner: 2,
  has_sla_plan: true,
  has_paid_sla_plan: true,
  sla_level: "Gold",
  wl_customer_portal_url: "https://example-label.test/demo/sla-portal",
  wl_user_support_id: "WL-DEMO-SUP-1001",
  wl_user_service_pin: "482913",
  consent_required: false,
  sla_unpaid_subscription: false,
  contract_amendment_required: false,
  two_factor_method: null,
  backup_codes_remaining: 8,
};

const emptyProfileImage = { thumb_small: "", thumb_medium: "" };

export const mockSubUsersData = [
  {
    id: 201,
    username: "demo-subuser@example-label.test",
    friendly_name: "Demo Subuser",
    email: "demo-subuser@example-label.test",
    first_name: "Demo",
    last_name: "Subuser",
    company: "Demo Catalog LLC",
    contract_expiry: "2027-06-30",
    distribution: true,
    release_transfer: true,
    is_active: true,
    is_blacklisted: false,
    profile_image: emptyProfileImage,
    street_and_number: "100 Demo Street",
    postal_code: "10115",
    city: "Berlin",
    country: "DE",
    phone: "+49 30 1234567",
    can_add_invoices: true,
    invoices: true,
    music_link: true,
    music_link_urlparts_allowance: 10,
    wl_user_type: "subscription",
    tenant_subscription_plan: "Starter",
    tenant_subscription_status: "active",
    track_allowance: 50,
    artist_allowance: 10,
    link_in_bio: true,
    tenant_subscription: {
      plan_name: "Starter",
      status: "active",
      product_id: 501,
      subscription_id: "sub_demo_501",
      amount: 29,
      currency: "eur",
      interval: "month",
      song_limit: 50,
      artist_limit: 10,
      music_link_limit: 10,
      link_landing_page_limit: 5,
      music_link_enabled: true,
      link_landing_page_enabled: true,
      features: ["Release distribution", "Music links", "Link landing pages"],
      deal_percent: 70,
      current_period_end: "2027-08-01T00:00:00.000Z",
      cancel_at_period_end: false,
      billing_portal_url: "/subscription",
    },
  },
  {
    id: 202,
    username: "catalog-team@example-label.test",
    friendly_name: "Catalog Team",
    email: "catalog-team@example-label.test",
    first_name: "Catalog",
    last_name: "Team",
    company: "Catalog Team",
    contract_expiry: "2026-12-31",
    distribution: false,
    release_transfer: false,
    is_active: true,
    is_blacklisted: false,
    profile_image: emptyProfileImage,
    street_and_number: "22 Sample Ave",
    postal_code: "SW1A 1AA",
    city: "London",
    country: "GB",
    phone: "+44 20 79460000",
    can_add_invoices: false,
    invoices: true,
    music_link: true,
    music_link_urlparts_allowance: 8,
    wl_user_type: "subscription",
    tenant_subscription_plan: null,
    tenant_subscription_status: null,
    tenant_subscription: null,
    track_allowance: 0,
    artist_allowance: 0,
    link_in_bio: false,
  },
  {
    id: 203,
    username: "inactive-partner@example-label.test",
    friendly_name: "Inactive Partner",
    email: "inactive-partner@example-label.test",
    first_name: "Inactive",
    last_name: "Partner",
    company: "Legacy Partners",
    contract_expiry: "2025-01-15",
    distribution: false,
    release_transfer: false,
    is_active: false,
    is_blacklisted: false,
    profile_image: emptyProfileImage,
    street_and_number: "",
    postal_code: "",
    city: "",
    country: "",
    phone: "",
    can_add_invoices: false,
    invoices: false,
    music_link: false,
    music_link_urlparts_allowance: 0,
    wl_user_type: "legacy",
    tenant_subscription_plan: null,
    tenant_subscription_status: null,
    tenant_subscription: null,
  },
];

/** Seed Stripe products / public plans for tenant subscriptions demo.
 * `amount` is in major currency units (EUR), matching formatPlanPriceDisplay.
 */
export const mockStripeProductsData = [
  {
    id: 501,
    name: "Starter",
    description: "Essential distribution tools for emerging labels.",
    features: ["Release distribution", "Music links", "Link landing pages"],
    amount: 29,
    currency: "eur",
    interval: "month",
    deal_percent: 70,
    song_limit: 50,
    artist_limit: 10,
    music_link_limit: 10,
    link_landing_page_limit: 5,
    music_link_enabled: true,
    link_landing_page_enabled: true,
    order: 0,
    is_active: true,
  },
  {
    id: 502,
    name: "Growth",
    description: "More capacity for growing catalogs.",
    features: ["Higher song limits", "Priority support", "Music links & landing pages"],
    amount: 79,
    currency: "eur",
    interval: "month",
    deal_percent: 75,
    song_limit: 200,
    artist_limit: 40,
    music_link_limit: 40,
    link_landing_page_limit: 20,
    music_link_enabled: true,
    link_landing_page_enabled: true,
    order: 1,
    is_active: true,
  },
  {
    id: 503,
    name: "Pro",
    description: "Unlimited-friendly allowances for established partners.",
    features: ["Large catalog support", "Advanced entitlements", "All modules"],
    amount: 149,
    currency: "eur",
    interval: "month",
    deal_percent: 80,
    song_limit: 1000,
    artist_limit: 200,
    music_link_limit: 100,
    link_landing_page_limit: 50,
    music_link_enabled: true,
    link_landing_page_enabled: true,
    order: 2,
    is_active: true,
  },
];

export const mockStripeConfigData = {
  has_secret_key: true,
  has_webhook_signing_secret: true,
  stripe_account_name: "Demo Stripe Account",
  stripe_livemode: false,
  secret_key_hint: "sk_test••••",
  webhook_signing_secret_hint: "whsec_••••",
  webhook_endpoint_id: "we_demo_endpoint",
  webhook_manual_required: false,
  webhook_url: "https://api.example-label.test/wl-tenant-stripe-webhook/1/",
  currency: "eur",
  tax_calculation_method: "inclusive",
  required_webhook_events: [
    "customer.subscription.created",
    "customer.subscription.updated",
    "customer.subscription.deleted",
    "invoice.paid",
    "invoice.payment_failed",
  ],
};

export const mockEmployeeAccountsData = [
  {
    id: 301,
    username: "label-manager",
    email: "manager@example-label.test",
    first_name: "Label",
    last_name: "Manager",
    employee_permission: "manager",
    is_active: true,
    profile_image: emptyProfileImage,
  },
  {
    id: 302,
    username: "content-review",
    email: "content@example-label.test",
    first_name: "Content",
    last_name: "Reviewer",
    employee_permission: "content_only",
    is_active: true,
    profile_image: emptyProfileImage,
  },
  {
    id: 303,
    username: "finance-lead",
    email: "finance@example-label.test",
    first_name: "Finance",
    last_name: "Lead",
    employee_permission: "full",
    is_active: true,
    profile_image: emptyProfileImage,
  },
];

export const mockSubuserInvoicesData = [
  {
    id: 401,
    invoice_number: "WL-DEMO-SUB-001",
    name: "Demo Subuser Invoice",
    owner: "Demo Subuser",
    sub_user: 201,
    issue_date: "15.04.2026",
    gross_amount: "350.00",
    tax_amount: "70.00",
    net_amount: "420.00",
    currency: 0,
    status: 0,
    invoice_pdf: "",
  },
  {
    id: 402,
    invoice_number: "WL-DEMO-SUB-002",
    name: "Catalog Team Invoice",
    owner: "Catalog Team",
    sub_user: 202,
    issue_date: "15.03.2026",
    gross_amount: "650.00",
    tax_amount: "130.00",
    net_amount: "780.00",
    currency: 0,
    status: 1,
    invoice_pdf: "",
  },
  {
    id: 403,
    invoice_number: "WL-DEMO-SUB-003",
    name: "Paid Subuser Invoice",
    owner: "Demo Subuser",
    sub_user: 201,
    issue_date: "15.02.2026",
    gross_amount: "200.00",
    tax_amount: "40.00",
    net_amount: "240.00",
    currency: 0,
    status: 3,
    invoice_pdf: "",
  },
];

export const mockAnnouncementsData = [
  {
    id: 501,
    title: "Demo platform launch",
    body: "This demo tenant includes sample distribution, finance, branding, and team data for guided walkthroughs.",
    created: "2026-05-01T10:00:00Z",
    is_read: false,
    is_dismissed: false,
  },
  {
    id: 502,
    title: "New deployment credits available",
    body: "Deployment credit history is preloaded so teams can review purchase and usage flows.",
    created: "2026-04-21T12:30:00Z",
    is_read: true,
    is_dismissed: false,
  },
];

export const mockDeploymentCreditsData = [
  {
    id: 601,
    quantity: 10,
    description: "Demo credit purchase",
    kind: "credit",
    balance: 10,
    created: "2026-04-20T09:00:00Z",
    stripe_receipt_url: "",
  },
];

export const mockTaxRatesData = [
  {
    id: 701,
    name: "Standard VAT",
    rate: "20.00",
    category: "vat_gst",
    calculation_method: "exclusive",
    legal_text: "VAT charged at the standard rate.",
  },
  {
    id: 702,
    name: "Reduced VAT",
    rate: "10.00",
    category: "vat_gst",
    calculation_method: "inclusive",
    legal_text: "Reduced rate applicable to qualifying items.",
  },
];

export const mockTenantInvoiceConfigData = {
  invoice_footer_text: "Thank you for your business.",
  invoice_company_name: "Demo Label GmbH",
  invoice_street_and_number: "Sample Street 12",
  invoice_postal_code: "10115",
  invoice_city: "Berlin",
  invoice_country: "DE",
  invoice_vat: "DE123456789",
  invoice_tax_nr: "27/123/45678",
  invoice_registry_nr: "HRB 123456",
};

export const mockInvoiceConfigurationData = {
  id: 801,
  invoice_prefix: "WL-DEMO",
  payment_terms_days: 14,
  tax_rates: mockTaxRatesData,
};

export const mockBrandingConfigData = {
  id: 901,
  theme_color: "#1f6feb",
  logo_url: "",
  logo_topbar_url: "",
  auth_form_alignment: "center",
  auth_form_display_logo: true,
};

export const mockSlaPlansData = [
  {
    id: 1001,
    name: "Gold Plan",
    description: "Demo access to SLA features, subuser invoices, and priority workflows.",
    price: "199.00",
    currency: "EUR",
    is_current: true,
  },
];

export { default as mockCopyrightInfringementsData } from "./disputeClaimsData";

export const mockTwoFactorData = {
  two_factor_method: null,
  available_methods: ["email", "auth"],
  backup_codes_remaining: 8,
};
